<template>
  <div class="zhengfuxinxigongkai">
    <h2 class="title">惠残服务</h2>
    <a href="javascript:;" @click="goList1()" class="box">
      <span class="ico"><img src="../../../assets/img/2.png" alt="" /></span>
      <span class="text">残疾人证办理</span>
    </a>
    <a href="javascript:;" class="box" @click="goList2()">
      <span class="ico"><img src="../../../assets/img/3.png" alt="" /></span>
      <span class="text">残疾人证查询</span>
    </a>
    <a href="javascript:;" class="box" @click="goList3()">
      <span class="ico"><img src="../../../assets/img/4.png" alt="" /></span>
      <span class="text">“两项”补贴业务办理</span>
    </a>
    <a href="javascript:;" class="box" @click="goList4()">
      <span class="ico"><img src="../../../assets/img/5.png" alt="" /></span>
      <span class="text">就业创业网络服务平台</span>
    </a>
		<a href="javascript:;" class="box" @click="goList5()">
		  <span class="ico"><img src="../../../assets/img/5.png" alt="" /></span>
		  <span class="text">全国残疾人按比例就业情况联网认证</span>
		</a>
		
  </div>
</template>

<script>
export default {
  name: 'zhengfuxinxigongkai',
  components: {},
  data() {
    return {


    };
  },
  methods: {
		goList1(){
			window.open('https://service.cdpf.org.cn/api?method=zclWssp.home.index')
		},
		goList2(){
			window.open('https://www.cdpf.org.cn/searchUser.html')
		},
		goList3(){
			window.open('https://zwfw.mca.gov.cn/apps/cjrlb/index.html')
		},
		goList4(){
			window.open('https://henan.cdpee.org.cn')
		},
		goList5(){
			window.open('http://gjzwfw.www.gov.cn/fwmh/crossProvincial/work/00017202900057.do')
		},
    // goList(type,title){
    //     let {
    //       href
    //     } = this.$router.resolve({
    //       path: "/List", // 这里写的是要跳转的路由地址
    //       query: {
    //         menuid: type,
    //         text:title
    //       } // 这里写的是页面参数
    //     });
    //     window.open(href, '_blank');
    // }
  }
};
</script>

<style scoped>
.zhengfuxinxigongkai {
  width: 200px;
  padding: 0 10px 0 0;
}
.title {
  height: 36px;
  line-height: 36px;
  font-size: 14px;
  text-align: left;
  color: red;
  font-weight: bold;
}
.box {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  align-items: center;
  padding: 5px;
  background: #eee;
  margin-top: 7px;
  font-size: 12px;
  border-radius: 5px;
}
.box .ico {
  width: 24px;
  height: 24px;
}
.box .ico img {
  width: 24px;
  height: 24px;
}
.box .text {
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/front/components/zhengfuxinxigongkai.vue